import * as React from 'react';
import { EmployeeAgencyTableChart } from '../../../interface/MyInterfaces';
import * as Helpers from '../../Common/Helpers';

interface RemainingColumnsProps {
    agyList: any;
    dataList: any;
    occ: any;
}

interface HeadingColumnsProps {
    agyList: any;
}

interface ColumnProps {
    value: any;
    class?: any;
    color?: string;
}

const Column: React.SFC<ColumnProps> = (props) => {
    //if (props.value == "&#xb1")
      //  return <td dangerouslySetInnerHTML={{ __html: "&#xb1" }}></td>
    //else    
    return <td className={props.class} style={{ backgroundColor: props.color}}>{props.value}</td>
}

const HeadingColumn: React.SFC<ColumnProps> = (props) => {
    //if (props.value == "&#xb1")
      //  return <th dangerouslySetInnerHTML={{ __html: "&#xb1" }}></th>
    //else     
    return <th style={{ backgroundColor: props.color }}>{props.value}</th>
}

const HeadingColumns: React.SFC<HeadingColumnsProps> = (props) => {
    var heading_columns: string[] = [];
    heading_columns.push("Occupational Category");


    var heading = ["Univ Pct", "Bnchmk Mean", "±", "Std"]
    props.agyList.map(function (value) {
        heading.map(function (heading_value, index) {
            heading_columns.push(heading_value);
//            return <th key={index}>{heading_value}</th>
        })
    })
    return (
        <tr>
            {
                heading_columns.map(function (column_value, index) {
                    index = Math.floor((index + 3) / 4);
                    return <HeadingColumn value={column_value} color={index % 2 == 0 ? 'white' : '#f2f2f2'}/>
                })
            }
        </tr>
    )
}

const RemainingColumns: React.SFC<RemainingColumnsProps> = (props) => {
    var remaining_columns: any = [];
    remaining_columns.push({ data: props.occ, outlier: "" });

    props.agyList.map(function (agy) {
        var datapoint = props.dataList.filter(x => x.agy == agy && x.occ == props.occ)
        if (datapoint.length > 0) {
            var outlier = Helpers.outlier(datapoint[0].avg, datapoint[0].std, datapoint[0].pct);
            remaining_columns.push({ data: datapoint[0].pct + "%", outlier: outlier.toString() });
            remaining_columns.push({ data: datapoint[0].avg + "%", outlier: outlier.toString() });
            remaining_columns.push({ data: "±", outlier: "" });
            remaining_columns.push({ data: datapoint[0].std + "%", outlier: outlier.toString() });
        }
        else {
            for (var i=0; i < 4; i++)
                remaining_columns.push({ data: "", outlier: "" });
        }
    })
    return (
        <tr>
            {
                remaining_columns.map(function (column_value, index) {
                    index = Math.floor((index+3)/ 4);
                    return <Column class={"color" + column_value.outlier} value={column_value.data} color={index%2==0? 'white' : '#f2f2f2'}/>
                })
            }
        </tr>
    )
}

export class EmployeeAgencyTable extends React.Component<EmployeeAgencyTableChart, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        //console.log(this.props.SpendingEmployeeAgencyTable);
        if (this.props.Top8CSV !== undefined && this.props.SpendingEmployeeAgencyTable !== undefined) {
            var agyList = this.props.Top8CSV.split(',');
            var agyHTMLList = agyList.map(function (value, index) {
                return <th key={index} className="center" colSpan={4} style={{ backgroundColor: index % 2 == 0 ? '#f2f2f2' : 'white', textAlign: 'center'}}>{value}</th>
            })


            var occList_repeating = this.props.SpendingEmployeeAgencyTable.map(x => x.occ);
            let occList = [...new Set(occList_repeating)];
            var dataList = this.props.SpendingEmployeeAgencyTable;
            var the_list_to_return = occList.map(function (occ, index) {
                return (
                    <RemainingColumns agyList={agyList} dataList={dataList} occ={occ}/>
                );
            });

            return <table className="agencytable">
                    <thead>
                        <tr><th></th>{agyHTMLList}</tr>
                        <HeadingColumns agyList={agyList} />
                    </thead>
                    <tbody>
                        {the_list_to_return}
                    </tbody>
                </table>
        }
        else {
            return <div>Loading...</div>
        }
        
    }
}